import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { requestFullLocationAccess } from "@src/appV2/Location/utils/permissions";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { TextButton } from "../../components/TextButton";
import { LocationPermissionsContent } from "./LocationPermissionsContent";

interface LocationPermissionsBottomSheetProps {
  modalState: UseModalState;
  isNotNowButtonVisible?: boolean;
  recentlyDisabled?: boolean;
}

export function LocationPermissionsBottomSheet(props: LocationPermissionsBottomSheetProps) {
  const { modalState, isNotNowButtonVisible = true, recentlyDisabled = false } = props;
  const history = useHistory();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              history.goBack();
              void requestFullLocationAccess();
            }}
          >
            Go To Settings
          </Button>
          <TextButton
            sx={{
              visibility: isNotNowButtonVisible ? "visible" : "hidden",
            }}
            onClick={() => {
              modalState.closeModal();
            }}
          >
            Not Now
          </TextButton>
        </DialogFooter>
      }
      canDismiss={false}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <LocationPermissionsContent recentlyDisabled={recentlyDisabled} />
      </DialogContent>
    </BottomSheet>
  );
}
